import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { WhatIfBody } from '@/components/whatIf/WhatIfBody'

export function WhatIfPage() {
  const [params, setParams] = useSearchParams()
  const initialPosition = params.get('position') ? Number(params.get('position')) : null
  const initialSellPct = params.get('sell_pct') ?? '0'

  const [positionId, setPositionId] = useState<number | null>(initialPosition)
  const [sellPct, setSellPct] = useState(initialSellPct)

  useEffect(() => {
    const next = new URLSearchParams()
    if (positionId !== null) next.set('position', String(positionId))
    if (sellPct !== '0' && Number(sellPct) > 0) next.set('sell_pct', sellPct)
    setParams(next, { replace: true })
  }, [positionId, sellPct, setParams])

  return (
    <AppShell>
      <article className="fade-in mx-auto max-w-6xl">
        <header className="mb-6 flex items-end justify-between border-b border-hairline pb-4">
          <div>
            <p className="tracked-caps text-[10px] text-faint">Simulation</p>
            <h1 className="mt-2 text-2xl text-ink">What-if-Simulator</h1>
          </div>
          <button
            onClick={() => {
              setPositionId(null)
              setSellPct('0')
            }}
            className="border border-hairline px-3 py-1.5 text-[11px] text-ink transition-colors hover:bg-panel"
          >
            Reset
          </button>
        </header>
        <WhatIfBody
          positionId={positionId}
          sellPct={sellPct}
          onPositionIdChange={setPositionId}
          onSellPctChange={setSellPct}
        />
      </article>
    </AppShell>
  )
}
